import React from "react";

// chakra imports
import {
  Box,
  Flex,
  Drawer,
  DrawerBody,
  Icon,
  useColorModeValue,
  DrawerOverlay,
  useDisclosure,
  DrawerContent,
  DrawerCloseButton,
} from "@chakra-ui/react";
import Content from "components/sidebar/components/Content";
import {
  renderThumb,
  renderTrack,
  renderView,
} from "components/scrollbar/Scrollbar";
import { Scrollbars } from "react-custom-scrollbars-2";
import PropTypes from "prop-types";

// Assets
import { IoMenuOutline } from "react-icons/io5";

const Sidebar = (props) => {
  const { routes } = props;

  let variantChange = "0.3s ease";
  let shadow = useColorModeValue(
    "0 8px 32px 0 rgba(35, 169, 121, 0.15)",
    "0 8px 32px 0 rgba(0, 0, 0, 0.37)",
  );
  // Chakra Color Mode
  let sidebarBg = useColorModeValue(
    "rgba(255, 255, 255, 0.85)",
    "rgba(26, 32, 44, 0.85)",
  );
  let sidebarMargins = "16px";
  let borderColor = useColorModeValue(
    "rgba(35, 169, 121, 0.2)",
    "rgba(35, 169, 121, 0.15)",
  );

  // SIDEBAR
  return (
    <Box
      display={{ base: "none", xl: "block" }}
      w="100%"
      position="fixed"
      minH="100%"
    >
      <Box
        bg={sidebarBg}
        // transition={variantChange}
        w="280px"
        h="calc(100vh - 32px)"
        m={sidebarMargins}
        minH="calc(100% - 32px)"
        // boxShadow={shadow}
        // backdropFilter="blur(12px)"
        borderRadius="2xl"
        border="1px solid"
        borderColor={borderColor}
        position="relative"
        _before={{
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          // background:
          //   "linear-gradient(180deg, rgba(35, 169, 121, 0.08) 0%, rgba(255, 255, 255, 0) 100%)",
          borderRadius: "2xl",
          pointerEvents: "none",
        }}
      >
        <Scrollbars
          autoHide
          renderTrackVertical={renderTrack}
          renderThumbVertical={renderThumb}
          renderView={renderView}
          style={{ height: "100%" }}
        >
          <Content routes={routes} />
        </Scrollbars>
      </Box>
    </Box>
  );
};

// FUNCTIONS
export function SidebarResponsive(props) {
  // Enhanced colors for glass morphism effect
  let sidebarBackgroundColor = useColorModeValue(
    "rgba(255, 255, 255, 0.85)",
    "rgba(26, 32, 44, 0.85)",
  );
  let menuColor = useColorModeValue("brand.500", "brand.500");
  let borderColor = useColorModeValue(
    "rgba(35, 169, 121, 0.2)",
    "rgba(35, 169, 121, 0.15)",
  );
  let drawerShadow = useColorModeValue(
    "0 8px 32px 0 rgba(35, 169, 121, 0.15)",
    "0 8px 32px 0 rgba(0, 0, 0, 0.37)",
  );
  // // SIDEBAR
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = React.useRef();

  const { routes } = props;
  // let isWindows = navigator.platform.startsWith("Win");
  //  BRAND

  return (
    <Flex display={{ base: "flex", xl: "none" }} alignItems="center">
      <Flex
        ref={btnRef}
        w="40px"
        h="40px"
        borderRadius="full"
        // bg="rgba(35, 169, 121, 0.1)"
        justify="center"
        align="center"
        onClick={onOpen}
        // transition="all 0.3s ease"
        cursor="pointer"
        // boxShadow="0 2px 10px rgba(35, 169, 121, 0.15)"
        _hover={{
          transform: "scale(1.05)",
          bg: "rgba(35, 169, 121, 0.15)",
          boxShadow: "0 4px 12px rgba(35, 169, 121, 0.25)",
        }}
        _active={{
          transform: "scale(0.95)",
        }}
      >
        <Icon as={IoMenuOutline} color={menuColor} w="22px" h="22px" />
      </Flex>
      <Drawer
        isOpen={isOpen}
        onClose={onClose}
        placement={document.documentElement.dir === "rtl" ? "right" : "left"}
        finalFocusRef={btnRef}
      >
        <DrawerOverlay backdropFilter="blur(12px)" bg="rgba(0, 0, 0, 0.15)" />
        <DrawerContent
          w={{ base: "280px", sm: "285px" }}
          maxW={{ base: "85vw", sm: "285px" }}
          bg={sidebarBackgroundColor}
          backdropFilter="blur(16px)"
          boxShadow={drawerShadow}
          position="relative"
          overflowY="auto"
          borderRight="1px solid"
          borderColor={borderColor}
          _before={{
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background:
              "linear-gradient(180deg, rgba(35, 169, 121, 0.08) 0%, rgba(255, 255, 255, 0) 100%)",
            pointerEvents: "none",
            zIndex: 0,
          }}
        >
          <DrawerCloseButton
            color="brand.500"
            size="lg"
            zIndex="3"
            // borderRadius="full"
            // bg="rgba(35, 169, 121, 0.05)"
            // boxShadow="0 2px 8px rgba(35, 169, 121, 0.1)"
            onClick={onClose}
            _focus={{ boxShadow: "none" }}
            _hover={{
              boxShadow: "0 4px 12px rgba(35, 169, 121, 0.2)",
              bg: "rgba(35, 169, 121, 0.15)",
              transform: "scale(1.05)",
              color: "#e05f10",
            }}
            // _active={{
            //   transform: "scale(0.95)",
            //   bg: "rgba(35, 169, 121, 0.2)",
            // }}
            // transition="all 0.2s ease"
          />
          <DrawerBody
            maxW={{ base: "100%", sm: "285px" }}
            px="0rem"
            pb="0"
            position="relative"
            zIndex="1"
          >
            <Box
              position="absolute"
              top="0"
              left="0"
              right="0"
              bottom="0"
              // bg="linear-gradient(180deg, rgba(35, 169, 121, 0.08) 0%, rgba(255, 255, 255, 0) 100%)"
              opacity="0.6"
              pointerEvents="none"
              zIndex="0"
            />
            <Scrollbars
              autoHide
              renderTrackVertical={renderTrack}
              renderThumbVertical={renderThumb}
              renderView={renderView}
            >
              <Box pt="5px">
                <Content routes={routes} onClose={onClose} />
              </Box>
            </Scrollbars>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Flex>
  );
}
// PROPS

Sidebar.propTypes = {
  logoText: PropTypes.string,
  routes: PropTypes.arrayOf(PropTypes.object),
  variant: PropTypes.string,
};

export default Sidebar;
